import { Plus, X } from "lucide-react";

const input = "h-9 rounded-lg border border-white/10 bg-white/5 px-3 text-sm outline-none focus:border-[#0066FF]";

export const OptionsEditor = ({ options, onChange }) => {
  const upd = (i, patch) => onChange(options.map((o, k) => (k === i ? { ...o, ...patch } : o)));
  const updVal = (i, j, patch) => upd(i, { values: options[i].values.map((v, k) => (k === j ? { ...v, ...patch } : v)) });

  return (
    <div className="space-y-4" data-testid="options-editor">
      {options.map((o, i) => (
        <div key={i} className="rounded-xl border border-white/10 p-4">
          <div className="flex flex-wrap items-center gap-2">
            <input className={input + " flex-1"} value={o.name} onChange={(e) => upd(i, { name: e.target.value })} placeholder="Nome opzione" data-testid={`option-name-${i}`} />
            <select className={input + " bg-[#12141A]"} value={o.kind} onChange={(e) => upd(i, { kind: e.target.value })}>
              <option value="select">Scelta singola</option><option value="checkbox">Extra (multipli)</option>
            </select>
            <label className="flex items-center gap-1.5 text-xs text-slate-400"><input type="checkbox" checked={!!o.required} onChange={(e) => upd(i, { required: e.target.checked })} />Obbligatoria</label>
            <button onClick={() => onChange(options.filter((_, k) => k !== i))} className="p-1 text-slate-500 hover:text-red-400" aria-label="Rimuovi opzione"><X className="h-4 w-4" /></button>
          </div>
          <div className="mt-3 space-y-2">
            {o.values.map((v, j) => (
              <div key={j} className="flex items-center gap-2">
                <input className={input + " flex-1"} value={v.value} onChange={(e) => updVal(i, j, { value: e.target.value })} placeholder="Valore" />
                <input type="number" step="0.01" className={input + " w-28"} value={v.markup} onChange={(e) => updVal(i, j, { markup: Number(e.target.value) || 0 })} title="Sovrapprezzo €" />
                <button onClick={() => upd(i, { values: o.values.filter((_, k) => k !== j) })} className="p-1 text-slate-500 hover:text-red-400" aria-label="Rimuovi valore"><X className="h-3.5 w-3.5" /></button>
              </div>
            ))}
            <button onClick={() => upd(i, { values: [...o.values, { value: "", markup: 0, default: false }] })} className="text-xs text-[#4D94FF]">+ Valore</button>
          </div>
        </div>
      ))}
      <button onClick={() => onChange([...options, { name: "", type: "SIZE", kind: "select", required: false, values: [] }])} data-testid="option-add-btn"
        className="flex items-center gap-1.5 text-sm text-[#4D94FF]"><Plus className="h-4 w-4" />Aggiungi opzione</button>
      <p className="text-xs text-slate-500">Il sovrapprezzo (€) viene sommato al prezzo base quando il cliente sceglie il valore.</p>
    </div>
  );
};
